import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataEcoLabelsActions } from "./eco-labels.actions";

// **************************************************************************
// ECO LABELS REDUCER
// **************************************************************************

const load = on(DataEcoLabelsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        ecoLabel: {
            ...state.data.ecoLabel,
            ecoLabelsLoading: true,
        },
    },
}));

const loadSuccess = on(DataEcoLabelsActions.loadSuccess, (state: ApplicationStore, { ecoLabels }) => ({
    ...state,
    data: {
        ...state.data,
        ecoLabel: {
            ...state.data.ecoLabel,
            ecoLabels,
            ecoLabelsLoading: false,
        },
    },
}));

const loadFailure = on(DataEcoLabelsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        ecoLabel: {
            ...state.data.ecoLabel,
            ecoLabelsLoading: false,
        },
    },
}));

export const ecoLabelsReducer = [load, loadSuccess, loadFailure];
